import { BaseButton } from './Button'
import { BaseControls } from './Controls'
import { BaseList } from './List'
import { BaseToolControls } from './ToolControls'
import { BaseWrapperScreen } from './Wrapper'

export const ScreenDefault = {
  Root: BaseWrapperScreen,
  Controls: BaseControls,
  ToolControls: BaseToolControls,
  List: BaseList,
  Button: BaseButton,
}
